import { useQuery } from "@tanstack/react-query";
import { emptyPage, Page, AutoComplete } from "@/model";
import autocompleteRepository from "@/repository/autoCompleteRepository";


const getData = async (agentId: number, page: number, size: number, keyword?: string, searchType?: string) => {
    const res = await autocompleteRepository.find(agentId, page, size, keyword, searchType);
    return res.data?.data || emptyPage<AutoComplete>();
};

export const usePaginatedAutocompletes = (agentId: number, page: number, size: number, keyword?: string, searchType?: string) => {
    return useQuery<Page<AutoComplete>>({
        queryKey: ['page-autocomplete', 'agent', agentId, 'page', page, 'size', size, 'keyword', keyword, 'searchType', searchType],
        queryFn: async () => getData(agentId, page, size, keyword, searchType),
        retry: false
    });
};
